package com.bikompanion.domain

/**
 * What identifies a bike globally: the number printed on it, plus the network that printed it.
 *
 * Bike numbers are assigned by the operator, so they are unique within a network and meaningless
 * outside it — bike 1234 in Barcelona's Bicing and bike 1234 in Paris' Vélib' are different bikes.
 * Both fields being [String] is exactly why this type exists: threading two bare strings through
 * every signature invites a silent argument swap that nothing would catch.
 *
 * Not the city: Barcelona runs Bicing *and* AMBici, with independent numbering. Not a coordinate
 * either — where a rider stands only resolves *which* network a bike belongs to; it is never part
 * of the bike's identity.
 */
data class BikeKey(
    val networkId: String,
    val bikeNumber: String,
)
